import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Wrapper = styled.div({
	display: 'flex',
	flexShrink: 0,
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: '3px',
	width: '24px',
	height: '24px',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Img = styled.img({
	maxWidth: '24px',
	maxHeight: '24px',
});
